import React, { useState } from 'react'
import HeaderTabLayout from '../../components/HeaderTabLayout'
import Layout from '../../components/Layout'
import TotalLeaveFormComp from '../../components/version-4/MasterForms/TotalLeaveFormComp'
import { useTotalLeave } from '../../hooks/CompanyConfiguration/useTotalLeave'

import { ROUTES } from '../../shared/constants'
function TotalLeaveForm({ totalLeave }) {
  const { addTotalLeave, loading, updateTotalLeave } = useTotalLeave()
  const [data, setdata] = useState({
    rank: '',
    leaveAllocated: '',
    leaveType: '',
  })
  const handleAddTotalLeave = () => {
    if (totalLeave) {
      updateTotalLeave({ ...data, totalLeaveId: totalLeave._id })
    } else {
      addTotalLeave({
        rank: data.rank,
        leaveAllocated: data.leaveAllocated,
        leaveType: data.leaveType,
      })
    }
  }
  React.useEffect(() => {
    if (totalLeave) {
      setdata({
        leaveType: totalLeave.leaveType._id,
        leaveAllocated: totalLeave.leaveAllocated,
        rank: totalLeave.rank,
      })
    }
  }, [totalLeave])
  return (
    <Layout heading="Leave Allocation" heading2={totalLeave ? 'Edit' : 'Add'} url1={ROUTES.TOTAL_LEAVE} none>
      <HeaderTabLayout
        heading={`${totalLeave ? 'Edit' : 'Add'} Leave Allocation`}
        content={<TotalLeaveFormComp state={data} setState={setdata} />}
        addContent={handleAddTotalLeave}
        redirect={ROUTES.TOTAL_LEAVE}
        loading={loading}
        state={data} setState={setdata}
      />
    </Layout>
  )
}

export default TotalLeaveForm
